import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import Banner from '../components/Banner';

const LuxuryYachts = () => {

    useEffect(() => {
        AOS.init({
            duration: 600, // Animation duration
            easing: "ease-in-sine", // Animation easing
        });
    }, []);

    return (
        <main id="yachts">
            
            <Banner img="assets/yachtimages/yachts-banner.webp" text="Luxury Yachts" />

            <section className="section-2">
                <div className="container">
                    <h2 className="text-center">Luxury Yachts</h2>
                    <p className="text-center">Experience unparalleled luxury and adventure on the open seas. </p>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="yacht-card">
                                <div className="image-wrapper">
                                    <img src="assets/images/19960_Mask_group-5.jpg" alt="" />
                                </div>
                                <div className="card-content">
                                    <h5>Feretti Yacht</h5>
                                    <small>78ft</small>
                                    <div>
                                        <div className="detail-item mt-2">
                                            <span className="label">Brand</span>
                                            <span className="value">Feretti</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Category</span>
                                            <span className="value">Luxury Yachts</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Size</span>
                                            <span className="value">78 ft. </span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Guest</span>
                                            <span className="value">12</span>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <a href="/yachtdetails.html"> <button className="know-more">Know More</button></a>
                                        <a href="/contact.html"> <button className="book-btn">Book Now</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="yacht-card">
                                <div className="image-wrapper">
                                    <img src="assets/images/56370_Screenshot_2024-07-01_163155.png" alt="" />
                                </div>
                                <div className="card-content">
                                    <h5>Feretti Yacht</h5>
                                    <small>78ft</small>
                                    <div>
                                        <div className="detail-item mt-2">
                                            <span className="label">Brand</span>
                                            <span className="value">Feretti</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Category</span>
                                            <span className="value">Luxury Yachts</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Size</span>
                                            <span className="value">78 ft. </span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Guest</span>
                                            <span className="value">12</span>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <a href="/yachtdetails.html"> <button className="know-more">Know More</button></a>
                                        <a href="/contact.html"> <button className="book-btn">Book Now</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="yacht-card">
                                <div className="image-wrapper">
                                    <img src="assets/images/7162214718.jpg" alt="" />
                                </div>
                                <div className="card-content">
                                    <h5>Feretti Yacht</h5>
                                    <small>78ft</small>
                                    <div>
                                        <div className="detail-item mt-2">
                                            <span className="label">Brand</span>
                                            <span className="value">Feretti</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Category</span>
                                            <span className="value">Luxury Yachts</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Size</span>
                                            <span className="value">78 ft. </span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Guest</span>
                                            <span className="value">12</span>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <a href="/yachtdetails.html"> <button className="know-more">Know More</button></a>
                                        <a href="/contact.html"> <button className="book-btn">Book Now</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="yacht-card">
                                <div className="image-wrapper">
                                    <img src="assets/images/19960_Mask_group-5.jpg" alt="" />
                                </div>
                                <div className="card-content">
                                    <h5>Feretti Yacht</h5>
                                    <small>78ft</small>
                                    <div>
                                        <div className="detail-item mt-2">
                                            <span className="label">Brand</span>
                                            <span className="value">Feretti</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Category</span>
                                            <span className="value">Luxury Yachts</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Size</span>
                                            <span className="value">78 ft. </span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Guest</span>
                                            <span className="value">12</span>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <a href="/yachtdetails.html"> <button className="know-more">Know More</button></a>
                                        <a href="/contact.html"> <button className="book-btn">Book Now</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="yacht-card">
                                <div className="image-wrapper">
                                    <img src="assets/images/56370_Screenshot_2024-07-01_163155.png" alt="" />
                                </div>
                                <div className="card-content">
                                    <h5>Feretti Yacht</h5>
                                    <small>78ft</small>
                                    <div>
                                        <div className="detail-item mt-2">
                                            <span className="label">Brand</span>
                                            <span className="value">Feretti</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Category</span>
                                            <span className="value">Luxury Yachts</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Size</span>
                                            <span className="value">78 ft. </span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Guest</span>
                                            <span className="value">12</span>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <a href="/yachtdetails.html"> <button className="know-more">Know More</button></a>
                                        <a href="/contact.html"> <button className="book-btn">Book Now</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="yacht-card">
                                <div className="image-wrapper">
                                    <img src="assets/images/7162214718.jpg" alt="" />
                                </div>
                                <div className="card-content">
                                    <h5>Feretti Yacht</h5>
                                    <small>78ft</small>
                                    <div>
                                        <div className="detail-item mt-2">
                                            <span className="label">Brand</span>
                                            <span className="value">Feretti</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Category</span>
                                            <span className="value">Luxury Yachts</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Size</span>
                                            <span className="value">78 ft. </span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Guest</span>
                                            <span className="value">12</span>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <a href="/yachtdetails.html"> <button className="know-more">Know More</button></a>
                                        <a href="/contact.html"> <button className="book-btn">Book Now</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="yacht-card">
                                <div className="image-wrapper">
                                    <img src="assets/images/19960_Mask_group-5.jpg" alt="" />
                                </div>
                                <div className="card-content">
                                    <h5>Feretti Yacht</h5>
                                    <small>78ft</small>
                                    <div>
                                        <div className="detail-item mt-2">
                                            <span className="label">Brand</span>
                                            <span className="value">Feretti</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Category</span>
                                            <span className="value">Luxury Yachts</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Size</span>
                                            <span className="value">78 ft. </span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Guest</span>
                                            <span className="value">12</span>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <a href="/yachtdetails.html"> <button className="know-more">Know More</button></a>
                                        <a href="/contact.html"> <button className="book-btn">Book Now</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="yacht-card">
                                <div className="image-wrapper">
                                    <img src="assets/images/56370_Screenshot_2024-07-01_163155.png" alt="" />
                                </div>
                                <div className="card-content">
                                    <h5>Feretti Yacht</h5>
                                    <small>78ft</small>
                                    <div>
                                        <div className="detail-item mt-2">
                                            <span className="label">Brand</span>
                                            <span className="value">Feretti</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Category</span>
                                            <span className="value">Luxury Yachts</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Size</span>
                                            <span className="value">78 ft. </span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Guest</span>
                                            <span className="value">12</span>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <a href="/yachtdetails.html"> <button className="know-more">Know More</button></a>
                                        <a href="/contact.html"> <button className="book-btn">Book Now</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="yacht-card">
                                <div className="image-wrapper">
                                    <img src="assets/images/7162214718.jpg" alt="" />
                                </div>
                                <div className="card-content">
                                    <h5>Feretti Yacht</h5>
                                    <small>78ft</small>
                                    <div>
                                        <div className="detail-item mt-2">
                                            <span className="label">Brand</span>
                                            <span className="value">Feretti</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Category</span>
                                            <span className="value">Luxury Yachts</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Size</span>
                                            <span className="value">78 ft. </span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="label">Guest</span>
                                            <span className="value">12</span>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <a href="/yachtdetails.html"> <button className="know-more">Know More</button></a>
                                        <a href="/contact.html"> <button className="book-btn">Book Now</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="destination-section gap">
                <div className="container">
                    <h2 className="text-center fw-bold">Destination</h2>
                    <div className="row mt-5">
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/45600_11._Burj_Al-Arab.jpg" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/45600_11._Burj_Al-Arab.jpg">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">burj Al Arab</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/41036_1._JBR.jpg" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/41036_1._JBR.jpg">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">JBR</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/66236_10._World_Island.jpg" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/66236_10._World_Island.jpg">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">World Island</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/17800_2._Bluewater_Island.jpg" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/17800_2._Bluewater_Island.jpg">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">Bluewater Island</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/64528_3._one-only-the-palm.jpg" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/64528_3._one-only-the-palm.jpg">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">One and only the palm</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/90302_4._Zabeel_Sarray.jpg" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/90302_4._Zabeel_Sarray.jpg">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">Zabeel Sarray</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/66860_5._Atlantis.jpg" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/66860_5._Atlantis.jpg">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">Atlantis</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/08299_6._Palm_jumeirah.jpg" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/08299_6._Palm_jumeirah.jpg">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">Palm jumeirah</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/34213_7._Royal_Amwaj.webp" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/34213_7._Royal_Amwaj.webp">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">Royal Amwaj</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/67870_8._Rixos_The_Palm.jpg" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/67870_8._Rixos_The_Palm.jpg">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">Rixos The Palm</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/90093_9._Logo_Island.webp" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/90093_9._Logo_Island.webp">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">Logo Island</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/73070_12._dubai_water_canal.jpg" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/73070_12._dubai_water_canal.jpg">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">dubai water canal</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/92333_13._Marasi_Marina.jpg" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/92333_13._Marasi_Marina.jpg">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">Marasi Marina</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div className="wrapper">
                                <div className="image-wrapper">
                                    <img src="assets/images/20380_14._Bulgari_Lagoon.jpg" alt="" />
                                </div>
                                <a data-fancybox="gallery" href="assets/images/20380_14._Bulgari_Lagoon.jpg">
                                    <div className="overlay">
                                        <div className="icon">
                                            <div className="text">Bulgari Lagoon</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div id="footer_load">

            </div>
        </main>
    )
}

export default LuxuryYachts